import React from 'react';
import { IStaffMember } from '../../staff-hook';
import { UserRoles } from '../../../../../../../Interfaces/responseTypes';
import {  Edit, Manager, Mobile, OpenSvg, SmallTrash, Waiter } from '../../../../../../../Assets/Icons';
import styles from './employeeCard.module.scss';

interface IProps {
    data: IStaffMember,
    index:number,
    onOpen: (user: IStaffMember) => void;
    onEdit:(data:IStaffMember,index:number)=>void
};

const EmployeeCard: React.FC<IProps> = ({ data,index, onOpen,onEdit }) => {

    const renderIcon = (type: UserRoles) => {
        switch (type) {
            case UserRoles.MANAGER:
                return Manager
            case UserRoles.WAITER:
                return Waiter
            default:
                return Waiter
        }
    }
    return (
        <div className={styles.container} >
            <div className={styles.infoBox}>
                <img src={renderIcon(data.user_role)} alt={`${data.user_role}.svg`} />
                <div className={styles.userName}>
                    {`${data.first_name} ${data.last_name}`}
                </div>
            </div>
                <div className={styles.phoneNumber}>
                    <img src={Mobile} alt='mobile.svg'/>
                    <p>
                        {data.phone_number}
                    </p>
                </div>
            <div className={styles.actionBox}>
              <img src={Edit} alt="edit.svg" className={styles.actionIcon} onClick={()=>onEdit(data,index)} />
              <img src={OpenSvg} alt="view.svg" className={styles.actionIcon} onClick={() => onOpen(data)}/>
              <img src={SmallTrash} alt="trash.svg" className={styles.actionIcon}/>
            </div>
        </div>
    )
}

export default EmployeeCard
